import React from 'react';
import logo from "assets/img/pebsteel.png"
import { LoadingSpinner } from "components/common";
import { formatDate, formatNumber } from "helpers/utils";
import generatePDF from 'react-to-pdf';
import WaiverHeaderPrint from "./WaiverHeaderPrint";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { CRM_WAIVER_FORM_ISO } from "app_config";
import "assets/scss/print-form.scss"
import { useState } from "react";
import { toast } from 'react-toastify';

const WaiverPrint = () => {
  const location = useLocation()
  const { waiver } = location.state
  const { project, buildings } = waiver

  const [showExporting, setExporting] = useState(false)

  const options = {
    filename: `waiver-${waiver.id}.pdf`,
    // default is `save`
    //method: 'open',
    // default is Resolution.MEDIUM = 3, which should be enough, higher values
    // increases the image quality but also the size of the PDF, so be careful
    // using values higher than 10 when having multiple pages generated, it
    // might cause the page to crash or hang.
    //resolution: Resolution.HIGH,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: 20,
      // default is 'A4'
      format: 'A4',
      // default is 'portrait'
      orientation: 'portrait',
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: 'image/png',
      qualityRatio: 1
    },
    // Customize any value passed to the jsPDF instance and html2canvas
    // function. You probably will not need this and things can break,
    // so use with caution.
    overrides: {
      // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
      pdf: {
        compress: true
      },
      // see https://html2canvas.hertzen.com/configuration for more options
      canvas: {
        useCORS: true
      }
    },
  }

  const getTargetElement = () => document.getElementById('waiver-form');

  const handleDownload = () => {
    setExporting(true)
    generatePDF(getTargetElement, options)
      .then(() => {
        setExporting(false);
      })
      .catch(error => {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF:', error)
        setExporting(false)
      })
  }

  const checkRow = (label, checked) => (
    <div className="tw-flex tw-items-center tw-mb-2 tw-mx-1">
      <div className="tw-flex-1">{label}</div>
      <div className="tw-w-1/3">
        <input type="checkbox" checked={checked || false} readOnly />
      </div>
    </div>
  );

  const checkItem = (label, checked) => (
    <label className="tw-flex tw-items-center tw-gap-1.5 tw-mb-1">
      <input type="checkbox" checked={checked || false} readOnly />
      {label}
    </label>
  );

  const paymentRow = (label, value) => (
    <div className="tw-flex tw-items-center tw-mb-2 tw-mx-1">
      <div className="tw-flex-1">{label}</div>
      <div className="tw-w-1/3">
        <span className="tw-text-blue-600">{value}</span>
      </div>
    </div>
  );

  return (
    <div className="tw-bg-white tw-rounded tw-border tw-border-solid tw-border-slate-200 tw-shadow-sm tw-m-2">
      <WaiverHeaderPrint download={handleDownload} />

      {showExporting && (
        <div className="tw-flex tw-items-center tw-justify-center">
          <LoadingSpinner message="Downloading..." />
        </div>
      )}


      <div id="waiver-form" className="tw-m-4 print-form tw-text-slate-900">
        <table className="tw-text-sm">
          <tr>
            <td colSpan="4" className="tw-text-center">
              <div className="tw-text-2xl tw-font-bold tw-mb-2">WAIVER FORM</div>
            </td>
            <td className="tw-text-center tw-py-4">
              <img
                className="tw-object-cover tw-rounded-sm tw-max-w-full"
                src={logo}
                alt="Logo Pebsteel"
                width="120"
                height="120"
              />
            </td>
          </tr>
          <tr className="tw-font-semibold">
            <td colSpan="2" className="tw-text-right">No.:</td>
            <td colSpan="3">{waiver.waiver_number}</td>
          </tr>
          <tr>
            <td className="tw-font-semibold">1. Project name:</td>
            <td colSpan="2" className="tw-font-semibold">
              <Link to={`/crm/projects/${project?.id}`}>{project?.name}</Link>
            </td>
            <td>Customer:</td>
            <td className="tw-font-semibold tw-text-blue-600">{project?.customer.name}</td>
          </tr>
          <tr>
            <td>
              <span className="tw-mx-2">Quotation / Job No:</span>
            </td>
            <td colSpan="4" className="tw-text-blue-600">{project.j_number ? project.j_number : project.q_number}</td>
          </tr>
          <tr>
            <td><span className="tw-mx-2">Main contract value:</span></td>
            <td className="tw-text-blue-600">${formatNumber(waiver.main_contract_value)}</td>
            <td>1st Addendum value:</td>
            <td className="tw-text-blue-600">${formatNumber(waiver.addendum_value_1st)}</td>
            <td>
              <div className="tw-flex">
                <div className="tw-flex-1">2nd Addendum value:</div>
                <div className="tw-w-1/4 tw-text-blue-600">${formatNumber(waiver.addendum_value_2st)}</div>
              </div>
            </td>
          </tr>
          <tr>
            <td className="tw-mx-2">
              <span className="tw-mx-2">Main contract weight:</span>
            </td>
            <td className="tw-text-blue-600">{formatNumber(waiver.main_contract_weight)} M.T</td>
            <td>1st Addendum weight:</td>
            <td className="tw-text-blue-600">{formatNumber(waiver.addendum_weight_1st)} M.T</td>
            <td>
              <div className="tw-flex">
                <div className="tw-flex-1">2nd Addendum weight:</div>
                <div className="tw-w-1/4 tw-text-blue-600">{formatNumber(waiver.addendum_weight_2st)} M.T</div>
              </div>
            </td>
          </tr>

          <tr className="tw-font-semibold">
            <td colSpan="5">
              2. Payment history (for repeat customer):
            </td>
          </tr>

          <tr className="tw-font-semibold">
            <td colSpan="3">
              3. Job Status:
            </td>
            <td colSpan="2">
              4. Payment term:
            </td>
          </tr>
          <tr>
            <td colSpan="3">
              {checkRow('Contract', waiver.job_status_contract)}
              {checkRow('LOI', waiver.job_status_loi)}
              {checkRow('JAF', waiver.job_status_jaf)}
              {checkRow('BOM & JAF comparison ( For releasing shipment waiver)', waiver.job_status_bom_jaf_comparison)}
              <div className="tw-flex tw-items-center tw-mb-2 tw-mx-1">
                <div className="tw-flex-1">Others</div>
                <div className="tw-w-1/3"></div>
              </div>
              <div>
                <span className="tw-text-blue-600" dangerouslySetInnerHTML={{ __html: waiver.job_status_other }}></span>
              </div>
            </td>
            <td colSpan="2">
              {paymentRow('1. Down payment', `${waiver.payment_term_dp}%`)}
              {paymentRow('2. Second payment after delivery of M/F', `${waiver.payment_term_second}%`)}
              {paymentRow('3. Third payment after deilivery of sheeting', `${waiver.payment_term_third}%`)}
              {paymentRow('4. Four payment after completion of erection', `${waiver.payment_term_four}%`)}
              {paymentRow('5. Final payment', `${waiver.payment_term_final}%`)}
              {paymentRow('Percentage of receiving:', `${waiver.percentage_of_receiving || 0.0}%`)}
              <div className="tw-flex tw-items-center tw-mb-2 tw-mx-1">
                <div className="tw-flex-1">Others</div>
                <div className="tw-w-1/3"></div>
              </div>
              <div>
                <span className="tw-text-blue-600" dangerouslySetInnerHTML={{ __html: waiver.payment_term_other }}></span>
              </div>
            </td>
          </tr>

          <tr className="tw-font-semibold">
            <td colSpan="5">
              5. Release for:
            </td>
          </tr>
          <tr>
            <td colSpan="5">
              <div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-text-sm tw-mx-1">
                <div>
                  {checkItem('Anchor bolt delivery', waiver.released_for_anchor_bolt)}
                  {checkItem('Fabrication', waiver.released_for_fabrication)}
                  {checkItem('Loading', waiver.released_for_loading)}
                  {checkItem('Shipment', waiver.released_for_shipment)}
                  {checkItem('Order material', waiver.released_for_order_material)}
                  <div className="tw-text-blue-600">{waiver.released_for_order_material}</div>
                </div>
                <div>
                  {checkItem('Approval dwgs & Estimate', waiver.released_for_apd_estimate)}
                  {checkItem('Shop dwgs', waiver.released_for_shop)}
                  {checkItem('Others (specify)', waiver.released_for_other)}

                  <span className="tw-text-blue-600" dangerouslySetInnerHTML={{ __html: waiver.released_for_other_specify }}></span>
                </div>
              </div>
            </td>
          </tr>

          <tr className="tw-font-semibold">
            <td colSpan="5">
              6. Reason for waiver:
            </td>
          </tr>
          <tr>
            <td colSpan="5">
              <table>
                <tr className="tw-bg-slate-50 tw-my-2">
                  <td width="5%">No.</td>
                  <td width="10%">Buildings</td>
                  <td width="85%">Reason</td>
                </tr>

                {buildings && buildings.map((building, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td className="tw-font-semibold tw-text-blue-600">{building.name}</td>
                    <td>
                      <span dangerouslySetInnerHTML={{ __html: building.reason }}></span>
                    </td>
                  </tr>
                ))}
              </table>
            </td>
          </tr>

          <tr className="tw-font-semibold">
            <td colSpan="2">
              7. Commitment date to clear waiver:
            </td>
            <td colSpan="3" className="tw-text-blue-600">
              {formatDate(waiver.commitment_date)}
            </td>
          </tr>
          <tr className="tw-text-center">
            <td className="tw-border tw-border-solid tw-border-slate-200" width="20%">Requestor</td>
            <td className="tw-border tw-border-solid tw-border-slate-200" width="20%">
              <div className="tw-p-1">
                General Manager/ Chief Rep
                <div className="tw-text-blue-600 tw-m-0 tw-p-0">(Approver)</div>
              </div>
            </td>
            <td className="tw-border tw-border-solid tw-border-slate-200" width="20%">
              <div className="tw-p-1">
                GM - Operation
                <div className="tw-text-blue-600 tw-m-0 tw-p-0">(Approver)</div>
              </div>
            </td>
            <td className="tw-border tw-border-solid tw-border-slate-200" width="20%">
              <div className="tw-p-1">
                Credit Controller
                <div className="tw-text-blue-600 tw-m-0 tw-p-0">(Verifier)</div>
              </div>
            </td>
            <td className="tw-border tw-border-solid tw-border-slate-200" width="20%">
              <div className="tw-p-1">
                Finance Controller
                <div className="tw-text-blue-600 tw-m-0 tw-p-0">(Approver)</div>
              </div>
            </td>
          </tr>
          <tr className="tw-text-center">
            <td className="tw-border tw-border-solid tw-border-slate-200">
              <div className="tw-text-blue-600 tw-my-3">{waiver.request?.by}</div>
              <div>Date: <span className="tw-text-blue-600">{waiver.request?.date}</span></div>
            </td>
            <td className="tw-border tw-border-solid tw-border-slate-200">
              <div className="tw-text-blue-600 tw-my-3">{waiver.general_sales_manager?.by}</div>
              {waiver.general_sales_manager?.date && (
                <div>Date: <span className="tw-text-blue-600">{waiver.general_sales_manager.date}</span></div>
              )}
            </td>
            <td className="tw-border tw-border-solid tw-border-slate-200">
              <div className="tw-text-blue-600 tw-my-3">{waiver.general_manager_operation?.by}</div>
              {waiver.general_manager_operation?.date && (
                <div>Date: <span className="tw-text-blue-600">{waiver.general_manager_operation.date}</span></div>
              )}
            </td>
            <td className="tw-border tw-border-solid tw-border-slate-200">
              <div className="tw-text-blue-600 tw-my-3">{waiver.credit_controller?.by}</div>
              {waiver.credit_controller?.date && (
                <div>Date: <span className="tw-text-blue-600">{waiver.credit_controller.date}</span></div>
              )}
            </td>
            <td className="tw-border tw-border-solid tw-border-slate-200">
              <div className="tw-text-blue-600 tw-my-3">{waiver.finance_controller?.by}</div>
              {waiver.finance_controller?.date && (
                <div>Date: <span className="tw-text-blue-600">{waiver.finance_controller.date}</span></div>
              )}
            </td>
          </tr>

        </table>

        <div className="tw-my-2 tw-text-sm">{CRM_WAIVER_FORM_ISO}</div>
      </div>

    </div>
  )
}

export default WaiverPrint
